import {AsyncPipe} from '@angular/common';
import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {ActivatedRoute} from '@angular/router';
import {Asset} from '@app/asset';
import {EmbedService} from '@app/embed/embed.service';
import {AsyncSpinnerComponent} from '@app/shared/async-spinner/async-spinner.component';
import {IdenticonPipe} from '@app/shared/identicon.pipe';
import {VideoComponent} from '@app/viewer/video/video.component';
import * as Sentry from "@sentry/angular";
import {Observable, of} from 'rxjs';
import {catchError, switchMap, take, tap} from 'rxjs/operators';
import videojs from 'video.js';

@Component({
    selector: 'frog-embed',
    templateUrl: './embed.component.html',
    styleUrls: ['./embed.component.scss'],
    imports: [VideoComponent, AsyncSpinnerComponent, MatIcon, AsyncPipe, IdenticonPipe],
})
export class EmbedComponent implements OnInit, AfterViewInit {
    @ViewChild('video') video: ElementRef;
    public url$: Observable<string>;
    public asset$: Observable<Asset>;
    public player: videojs.Player;
    public loading: boolean;

    constructor(
        private embedService: EmbedService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.loading = true;
    }

    ngOnInit(): void {
        this.asset$ = this.activatedRoute.params.pipe(
            take(1),
            switchMap((params) => {
                return this.embedService.get(params.assetId);
            }),
            tap(() => (this.loading = false)),
            catchError((err) => {
                Sentry.captureMessage("Error when trying to get an embedded asset", {
                    extra: {
                        error: err
                    }
                });
                this.loading = false;
                return of(null);
            }),
        );
    }

    ngAfterViewInit() {}
}
